import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { StripeApiKeyString } from "../../constants/StripeApiKey";
import LoadingSpinner from "../../components/LoadingSpinner";
//styled
export default function PremiumClubMembershipCanceled({ notification }) {
  const [club, setClub] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [checkout, setCheckout] = useState(false);
  const [checkoutComplete, setCheckoutComplete] = useState(false);
  const { user } = useAuthContext();
  const stripePromise = loadStripe(StripeApiKeyString);
  const navi = useNavigate();
  const handleComplete = () => {
    setCheckoutComplete(true);
  };
  const options = {
    clientSecret,
    onComplete: handleComplete,
  };
  const handleGoPremium = async () => {
    setIsLoading(true);
    try {
      const premResponse = await axios.post(
        `${ApiConnectionString}/api/PlatformCheckout/NewSubscription/${club.id}`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (premResponse.status == 200) {
        setClientSecret(premResponse.data);
        setCheckout(true);
      }
    } catch (error) {
      // Handle error here
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // You can set error state here if needed
    } finally {
      setIsLoading(false); // Stop loading state in any case
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div className="container bg-white text-center">
        <LoadingSpinner />
      </div>
    );
  } else if (club) {
    if (checkout) {
      return (
        <div className="container bg-white">
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
          {checkoutComplete && (
          <p className="text-success">
          Your subscription was successful, and your club is now active. Please allow a moment for the system to update.
        </p>
        
          )}
        </div>
      );
    } else {
      return (
        <div className="container bg-white text-center">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Payment Resolved</p>
          </div>
          <p>{notification.content}</p>
          <p
            onClick={() => navi(`/myoneclub/${club.id}`)}
            className="fw-bold red-text pointer"
          >
            {club.name}
          </p>
          <div
            onClick={() => navi(`/myoneclub/${club.id}`)}
            className="circle-crop mx-auto"
          >
            <img
              src={
                club.image
                  ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                  : NoImagePlaceholder
              }
              alt="Club Image"
              className="mt-0 pointer"
            />{" "}
          </div>

          <p>
            If you would like this club to be a premium club again, please press
            "Renew" below.
          </p>
          <div className="d-flex justify-content-center">
            {!club.premium ? (
              <p className="saveChanges-button" onClick={handleGoPremium}>
                Renew
              </p>
            ) : (
              <p>Premium membership has now been renewed.</p>
            )}
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="container bg-white">
        <div className="blueBanner mt-2">
          <p className=" fw-bold p-2">Payment Resolved</p>
        </div>
        <p>Not Found</p>
      </div>
    );
  }
}
